export default function Divider({text}) {
  return (
    <div class="relative flex items-center justify-center w-full h-10">
      <span class="absolute inset-x-0 top-1/2 border-t border-zi-blue-light opacity-25"></span>
      <p className="px-2 bg-zi-bg2-light dark:bg-zi-bg2-dark text-xs text-zi-blue-light z-10">
        {text}
      </p>
    </div>
  )
}